const STORAGE_KEY = "caseDisplayNameById";

function readMap(): Record<string, string> {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") return {};
    return parsed as Record<string, string>;
  } catch {
    return {};
  }
}

function writeMap(map: Record<string, string>): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* ignore quota / private mode */
  }
}

export function cacheCaseDisplayName(caseId: string | number, name: string): void {
  const trimmed = String(name ?? "").trim();
  if (!trimmed) return;
  const map = readMap();
  map[String(caseId)] = trimmed;
  writeMap(map);
}

export function getCachedCaseDisplayName(caseId: string | number): string | undefined {
  const map = readMap();
  const value = map[String(caseId)];
  const trimmed = String(value ?? "").trim();
  return trimmed || undefined;
}
